<!-- 订单为空 -->
<template>
  <div class="emptyIndent">
    <div :class="[emptyName === 'noProductList' ? 'product' : 'hide']"></div>
    <div :class="[emptyName === 'noProductList' ? 'productDiv' : '']">
      <img :src="imgUrl" />
    </div>
    <p>{{ text }}</p>
  </div>
</template>
<script>
export default {
  props: {
    emptyName: {
      type: String,
    },
  },
  data() {
    return {
      text: '暂无地址哦～',
      imgUrl: require('@/assets/img/noData/noAddress.png'),
    };
  },
  watch: {},
  mounted() {},
  created() {
    this.initData(this.emptyName);
  },
  methods: {
    initData(name) {
      let text = '暂无地址哦～';
      let img = require('@/assets/img/noData/noAddress.png');
      switch (name) {
        case 'noAddress':
          text = '暂无地址哦～';
          img = require('@/assets/img/noData/noAddress.png');
          break;
        case 'noIndent':
          text = '暂无订单哦～';
          img = require('@/assets/img/noData/noIndentH5.png');
          break;
        case 'noProductList':
          text = '暂无课程';
          img = require('@/assets/img/noData/noProductList.png');
          break;
        case 'delivered':
          text = '暂无已发货的包裹';
          img = require('@/assets/img/noData/noPackage.png');
          break;
        case 'toBeDelivered':
          text = '暂无待发货的包裹';
          img = require('@/assets/img/noData/noPackage.png');
          break;
        case 'noEvaluation':
          text = '空空如也~';
          img = require('@/assets/img/noData/noEvaluation.png');
          break;
        case 'toHandout':
          text = '您还没有需要发货的快递，先去下单吧~';
          img = require('@/assets/img/noData/noHandout.png');
          break;
        case 'noGroupOrder':
          text = '暂无拼团活动订单';
          img = require('@/assets/img/noData/noGroupOrder.png');
          break;
        case 'tree':
          text = '暂无课程目录';
          img = require('@/assets/img/noData/tree.png');
          break;
        case 'noPullNew':
          text = '暂无助力活动哦～';
          img = require('@/assets/img/noData/nopullnew.png');
          break;
        case 'noAgreement':
          text = '您还没有协议哦～';
          img = require('@/assets/img/noData/noLocation.png');
          break;
        case 'noGame':
          text = '暂无游戏活动哦～';
          img = require('@/assets/img/noData/nopullnew.png');
          break;
        case 'noHandsel':
          text = '暂无待支付定金';
          img = require('@/assets/img/noData/noIndentH5.png');
          break;
        case 'noReport':
          text = '学习报告正在生成中，请稍后查看';
          img = require('@/assets/img/noData/noSearch.png');
          break;
        case 'businessOrder':
          text = '暂无快递信息';
          img = require('@/assets/img/noData/noBusinessOrder.png');
          break;
        default:
      }
      this.text = text;
      this.imgUrl = img;
    },
  },
};
</script>

<style lang="scss" scoped>
.emptyIndent {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100vh - 244px);
  .hide {
    widows: 100%;
    height: 257px;
    background-color: #f9f9f9;
  }
  .product {
    widows: 100%;
    height: 257px;
  }
  .productDiv {
    display: flex;
    align-items: center;
    justify-content: center;
    // width: 272px;
    // height: 272px;
    img {
      width: 290px;
      //   height: 290px;
    }
  }
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 272px;
    height: 272px;
    // img{
    //   width: 238px;
    //   height: 182px;
    // }
    img {
      width: 320px;
      //   height: 320px;
    }
  }
  p {
    // width: 174px;
    height: 40px;
    color: #a5a5a5;
    font-weight: 400;
    font-size: 29px;
    line-height: 40px;
  }
}
</style>
